import React from 'react'
import { Row, Col, Button, Form } from 'react-bootstrap'
import { SubHeader } from '../../../components'
import { regEx } from '../../../../../resources/Utils'

class SubAccountProfile extends React.Component {

  constructor(props) {
    super(props)
  
    this.state = {
      subAccountId: null, 
      accountNo: "", 
      paymentCallbackUrl : "",
      registerCallbackUrl : ""
    }
  }
  
  onChange = (name, value) => {
    this.setState({[name]: value})
  }

  render() {
    let {props} = this
    return (
      <React.Fragment>
        <SubHeader text="Merchant Sub-Account" />
        <Row>
          <Col>
            <SubAccountForm list={props.subAccountProfile} />
          </Col>
        </Row>
      </React.Fragment>
    )
  }
}
export default SubAccountProfile

const SubAccountForm = ({ list = [] }) => {
  const subAccountList = list.map((value, index, arr) => {
    return (
      <Row key={value.subAccountId} className="pb-2">
        <Col sm={2} className="pr-2">
          <Form.Control 
              maxLength={10}
              name={"subAccountId"} 
              disabled
              defaultValue={value.subAccountId} 
              placeholder={"Auto Generate"}  />
        </Col>
        <Col sm={2} className="pr-2">
          <Form.Control 
              maxLength={10}
              name={"accountNumber"}
              disabled
              required
              value={value.accountNumber} 
              placeholder={"Enter Account Number"}
          />
        </Col>
        <Col sm={3} className="pr-2">
          <Form.Control
              name={"paymentCallbackUrl"}
              disabled
              required
              value={"".padStart(value.paymentCallbackUrl.length,"*")} 
              pattern={regEx.URL}
              title="URL format is invalid (eg. http://www.example.com)"
              placeholder={"Enter Payment Callback URL"}
          />
        </Col>
        <Col sm={3} className="pr-2">
          <Form.Control
              name={"registerCallbackUrl"}
              disabled
              required
              value={"".padStart(value.registerCallbackUrl.length,"*")} 
              pattern={regEx.URL}
              title="URL format is invalid (eg. http://www.example.com)"
              placeholder={"Enter Register Callback URL"}
          />
        </Col>
      </Row>
      )
    }
  );

  return (
    <React.Fragment>
      <Row className="pt-2">
          <Col sm={2} className="pr-2">
            <Form.Label className={"text-grey font-weight-bold medium required"}>Sub-Account ID</Form.Label>
          </Col>
          <Col sm={2} className="pr-2">
            <Form.Label className={"text-grey font-weight-bold medium required"}>Account Number</Form.Label>
          </Col>
          <Col sm={3} className="pr-2">
            <Form.Label className={"text-grey font-weight-bold medium required"}>Payment Callback URL</Form.Label>
          </Col>
          <Col sm={3} className="pr-2">
            <Form.Label className={"text-grey font-weight-bold medium required"}>Register Callback URL</Form.Label>
          </Col>
      </Row>
      {subAccountList}
    </React.Fragment>
  );
   
}